const Spinner = ({message="Loading data...", showMessage=true, size=60})=>{
	const borderSize = Math.min(10, Math.max(2, size / 10));
	const ringStyle = {
		width: size,
		height: size,
		borderWidth: borderSize,
		margin: size / 10,
	}

	const ringBoxStyle = {
		width: size * 1.15,
		height: size * 1.15
	}
	return(
		<div className="flex flex-col justify-center items-center">
			<div className="lds-ring" style={ringBoxStyle}>
				<div style={ringStyle}></div>
				<div style={ringStyle}></div>
				<div style={ringStyle}></div>
				<div style={ringStyle}></div>
			</div>
			{
	        	showMessage && <p className="mt-2 text-grey-text">{message}</p>
			}
	    </div>
	)
}

export const SmallSpinner = ({ className = "" }) => (
	<div className={`w-4 h-4 border-thick border-t-primary border-black/10 rounded-full animate-spin ${className}`}></div>
)

export default Spinner;